import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner, useIntl } from "@metsooutotec/modes-react-components";
var LowSpinner = function (_a) {
    var id = _a.id;
    var formatMessage = useIntl().formatMessage;
    return _jsx(Spinner, { text: formatMessage(id), style: { zIndex: 8 } });
};
export default LowSpinner;
